import 'jquery';
/* eslint-disable no-useless-escape */

export default () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    const isIE = (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./));
    if(isIE) $('body').addClass('is-ie');
    return isIE;

};


// WEBPACK FOOTER //
// ./scripts/modules/isIEBrowser.js